module.exports = __webpack_public_path__ + "static/media/Testimonials-banner.757ba71a.jpg";